// Standard error messages
const ERROR_MESSAGES = {
  API_FAILURE: 'Error received from the SmarterProctoring API',
  GETTING_STEP_ERROR: 'Error while getting the next step',
  SPEECH_NOT_SUPPORTED_ERROR: 'Speech is not supported in this browser',
  USER_NOT_FOUND_ERROR: 'User Not Found',
  SP_SETUP_SESSION_ERROR: 'Error Occurred Setting Up SP Session',
  WEBCAM_NOT_FOUND_ERROR: 'Previously Selected Webcam Cannot Be Found',
  PARAMS_NOT_FOUND_ERROR: 'Necessary Params Not Found',
  PHOTO_TYPE_NOT_ALLOWED: 'Photo Type Not Allowed',
};

// Custom Error Classes
class ApiError extends Error {
  constructor(message = ERROR_MESSAGES.API_FAILURE) {
    super(message);
    this.name = 'ApiError';
  }
}

class GettingStepError extends Error {
  constructor(message = ERROR_MESSAGES.GETTING_STEP_ERROR) {
    super(message);
    this.name = 'GettingStepError';
  }
}

class SpeechNotSupportedError extends Error {
  constructor(message = ERROR_MESSAGES.SPEECH_NOT_SUPPORTED_ERROR) {
    super(message);
    this.name = 'SpeechNotSupportedError';
  }
}

class UserNotFoundError extends Error {
  constructor(message = ERROR_MESSAGES.USER_NOT_FOUND_ERROR) {
    super(message);
    this.name = 'UserNotFoundError';
  }
}

class SpSessionSetupError extends Error {
  constructor(message = ERROR_MESSAGES.SP_SETUP_SESSION_ERROR) {
    super(message);
    this.name = 'SpSessionSetupError';
  }
}

class WebcamNotFoundError extends Error {
  constructor(message = ERROR_MESSAGES.WEBCAM_NOT_FOUND_ERROR) {
    super(message);
    this.name = 'WebcamNotFoundError';
  }
}

class ParamsNotFoundError extends Error {
  constructor(message = ERROR_MESSAGES.PARAMS_NOT_FOUND_ERROR) {
    super(message);
    this.name = 'ParamsNotFoundError';
  }
}

class PhotoTypeNotAllowedError extends Error {
  constructor(message = ERROR_MESSAGES.PHOTO_TYPE_NOT_ALLOWED) {
    super(message);
    this.name = 'PhotoTypeNotAllowedError';
  }
}

export {
  ERROR_MESSAGES,
  ApiError,
  GettingStepError,
  SpeechNotSupportedError,
  UserNotFoundError,
  SpSessionSetupError,
  WebcamNotFoundError,
  ParamsNotFoundError,
  PhotoTypeNotAllowedError,
};
